import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceService } from 'src/app/services/invoice.service';
import { HelpersService } from 'src/app/services/helpers.service';

@Component({
  selector: 'app-workshop-jobcard-add-lineitem-note',
  templateUrl: './workshop-jobcard-add-lineitem-note.component.html',
  styleUrls: ['./workshop-jobcard-add-lineitem-note.component.scss']
})
export class WorkshopJobcardAddLineitemNoteComponent {

  @Input() public lineItem: any = {};
  @Output() public lineItemUpdated: EventEmitter<any> = new EventEmitter<any>();

  public itemNote: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private invoiceService: InvoiceService,
    private helpersService: HelpersService
  ) { }

  ngOnInit() {
    if (this.lineItem && this.lineItem.LineItemNote) {
      this.itemNote = this.lineItem.LineItemNote;
    }
  }


  addNote() {
    if(this.itemNote && this.itemNote.trim() != "")
    {
      this.lineItem.LineItemNote = this.itemNote;
      this.lineItemUpdated.emit(this.lineItem);
      this.activeModal.close();
    }
  }

  removeNote(){
    this.lineItem.LineItemNote = null;
    this.activeModal.close();
  }


  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    this.addNote();
  }

}
